import React from 'react';
import { Heart, Mail, Phone } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ background: 'var(--text-primary)', color: 'white', padding: '3rem 0 1.5rem' }}>
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="heading-3 mb-4" style={{ color: 'white' }}>Curis Path</h3>
            <p className="body-small" style={{ color: 'rgba(255, 255, 255, 0.8)', lineHeight: '1.6' }}>
              Your trusted partner for world-class medical care in India. 
              Experience premium healthcare at affordable costs.
            </p>
          </div>

          <div>
            <h4 className="body-medium font-semibold mb-4" style={{ color: 'white' }}>Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => document.getElementById('specialties').scrollIntoView({ behavior: 'smooth' })}
                  className="body-small hover:opacity-70 transition-opacity"
                  style={{ color: 'rgba(255, 255, 255, 0.8)' }}
                >
                  Our Specialties
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('hospitals').scrollIntoView({ behavior: 'smooth' })}
                  className="body-small hover:opacity-70 transition-opacity"
                  style={{ color: 'rgba(255, 255, 255, 0.8)' }}
                >
                  Partner Hospitals
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('doctors').scrollIntoView({ behavior: 'smooth' })}
                  className="body-small hover:opacity-70 transition-opacity"
                  style={{ color: 'rgba(255, 255, 255, 0.8)' }}
                >
                  Our Doctors
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('enquiry').scrollIntoView({ behavior: 'smooth' })}
                  className="body-small hover:opacity-70 transition-opacity"
                  style={{ color: 'rgba(255, 255, 255, 0.8)' }}
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="body-medium font-semibold mb-4" style={{ color: 'white' }}>Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Phone size={16} style={{ color: 'rgba(255, 255, 255, 0.6)' }} />
                <a 
                  href={`tel:${contactInfo.phone}`}
                  className="body-small hover:opacity-70 transition-opacity"
                  style={{ color: 'rgba(255, 255, 255, 0.8)' }}
                >
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} style={{ color: 'rgba(255, 255, 255, 0.6)' }} />
                <a 
                  href={`mailto:${contactInfo.email}`}
                  className="body-small hover:opacity-70 transition-opacity"
                  style={{ color: 'rgba(255, 255, 255, 0.8)' }}
                >
                  {contactInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div 
          className="pt-6"
          style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}
        >
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-4">
            <p className="body-small flex items-center gap-2" style={{ color: 'rgba(255, 255, 255, 0.6)' }}>
              Made with <Heart size={14} fill="rgba(255, 255, 255, 0.6)" /> for better healthcare access
            </p>
            <p className="body-small" style={{ color: 'rgba(255, 255, 255, 0.6)' }}>
              © {currentYear} Curis Path. All rights reserved.
            </p>
          </div>
          <div className="text-center">
            <p className="caption" style={{ color: 'rgba(255, 255, 255, 0.5)' }}>
              Curis Path is a medical tourism facilitation service. We do not provide medical advice or treatment. 
              All medical procedures are performed by licensed healthcare professionals at accredited hospitals. 
              By using our services, you agree to our terms and conditions and acknowledge our disclaimer.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;